import React from 'react';
import type { Modify } from 'corgi-types';

import BannerTextBoxContent from '../../../banner/TextBoxContent';
import { PrismicSliceType } from '../../../enums';
import TeaserTextBoxContent from '../../../teaser/TextBoxContent';
import type { BannerProps, TeaserProps } from '../../../types';
import { checkMissingText } from '../../utils/text';
import DesktopTextBox from '../containers/DesktopTextBox';
import FloatingTextBox from '../containers/FloatingTextBox';
import GridConstraintOverlay from '../containers/GridConstraintOverlay';
import MobileTextBox from '../containers/MobileTextBox';
import LegalDisclaimer from '../content/LegalDisclaimer';
import MediaContainer from '../MediaContainer';

type BigVariantProps = Modify<
  Omit<BannerProps | TeaserProps, 'slimImage' | 'bigImage' | 'tracking' | 'video'>,
  {
    onClick?: () => void;
    onCtaClick?: () => void;
    onVoucherClick?: () => void;
    ref?: React.Ref<HTMLDivElement>;
    children: React.ReactNode;
  }
>;

const BigVariant = ({ ref, type, children, isFullWidth, ...props }: BigVariantProps) => {
  const isTextMissing = checkMissingText(props);

  const TextBoxContent =
    type === PrismicSliceType.TopTeaser ? TeaserTextBoxContent : BannerTextBoxContent;
  const TextBoxContainer = props?.isViewportWide ? GridConstraintOverlay : React.Fragment;

  return (
    <>
      <MediaContainer ref={ref} {...props}>
        <TextBoxContainer>
          {isFullWidth ? (
            <FloatingTextBox isTextMissing={isTextMissing} {...props}>
              <TextBoxContent {...props} isFloatingTextBox={true} />
            </FloatingTextBox>
          ) : (
            <DesktopTextBox isTextMissing={isTextMissing} {...props}>
              <TextBoxContent {...props} isFloatingTextBox={false} />
            </DesktopTextBox>
          )}
        </TextBoxContainer>
        {children}
        <LegalDisclaimer
          legalDisclaimerContent={props?.legalDisclaimerContent}
          textContainerPosition={props?.textContainerPosition}
          isFullWidth={isFullWidth}
        />
      </MediaContainer>
      <MobileTextBox isTextMissing={isTextMissing} {...props}>
        <TextBoxContent {...props} isFloatingTextBox={false} />
      </MobileTextBox>
    </>
  );
};

BigVariant.displayName = 'BigVariant';

export default BigVariant;
